module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAhCAYAAAAoNdCeAAAACXBIWXMAAAsSAAALEgHS3X78AAABIklEQVRIx+2XgQ2EIAxFHcERHIERHMERGIERGOFGcBRGuBEYgQ041I/hOCGA1eQSTX6ignltobV01tqOQu7qnWYn42Qhg3f9OocINDjpABJLr3OIYCoD8npTgMYC0CYCmHxgFOulL4Uhp17FkE3qem/8tl8MJPJGYlxGhmg/9lVBUAXmYLLG85DxZrGYFRsMEM+EwKS8aViCigrgF9p527ixiuqa91CcTJVijzRBASgP4d/BahJ0z5lWGK/cjYtxYxMMxLkSaMPeogoGoDhIYA3PGarFUTpMUUmbEG6J+/4HFnzAkOgs8e8yiUTnibHdoNZOSjWEnZ/ZxjxTN48rEEFjqp6GhwIm7oQNt8EqQik7wiNTDijJjkxRSCXSQeF+byE+FQUI0qJEVBkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/share.png
// module id = 183
// module chunks = 0